import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AnnouncementBar, StickyCTA, Footer } from "@/components/chrome";
import Hero from "@/components/Hero";
import { Manifesto, ImageBreak, NervousSystem } from "@/components/sections2";
import { ForHerHim, Ritual, EditorialMarquee, SoloTogether } from "@/components/sections3";
import { GoldenRoot, Testimonials, BigStatement } from "@/components/sections4";
import { Offer, Intimacy, FAQ, Contact, FinalCTA } from "@/components/sections5";
import { PaymentSuccess, PaymentCancel } from "@/pages/payment";

function Landing() {
  return (
    <main className="bg-[#050505] text-[#fdfbf7] ff-sans">
      <AnnouncementBar />
      <Hero />
      <Manifesto />
      <ImageBreak />
      <NervousSystem />
      <ForHerHim />
      <Ritual />
      <EditorialMarquee />
      <SoloTogether />
      <GoldenRoot />
      <Testimonials />
      <BigStatement />
      <Offer />
      <Intimacy />
      <FAQ />
      <Contact />
      <FinalCTA />
      <Footer />
      <StickyCTA />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <Toaster theme="dark" position="top-center" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
